import React from "react";
import { withStyles, withTheme, Tabs, Tab } from "@material-ui/core";
import { compose } from "recompose";
import EndOfDayRouteCompliance from "./EndOfDayRouteCompliance";
import DriverDecisionPerStop from "./DriverDecisionPerStop";
import NoData from "./NoData";

const styles = (theme) => ({
  subModulePart: {
    borderRight: `1px solid ${theme.AppBGColor}`,
    height: "100%",
  },
  tabsIndicator: {
    backgroundColor: theme.HeaderSelectedText,
  },
  tabRoot: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "24px",
    color: theme.HeaderSelectedText,
    minWidth: 100,
    "&:hover": {
      background: "rgba(5, 167, 146, 0.05)",
      color: theme.HeaderSelectedText,
    },
    "&$tabSelected": {
      background: "rgba(5, 167, 146, 0.05)",
      color: theme.HeaderSelectedText,
    },
    "&:focus": {
      background: "rgba(5, 167, 146, 0.05)",
      color: theme.HeaderSelectedText,
    },
  },
  tabSelected: {
    background: "rgba(5, 167, 146, 0.05)",
    color: theme.HeaderSelectedText,
  },
});

class NextStopComplianceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
    };
  }

  handleChange = (event, value) => {
    this.props.onTabChange(value);
  };

  stopChange = (stop) => {
    this.props.onStopClick(stop);
  };

  componentDidUpdate(prevProps) {
    if (this.props.value != prevProps.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    const {
      classes,
      selectedRoute,
      stopDetails,
      onStopClick,
      stopIndex,
      terminalCode,
      dataUpdateInProgress,
    } = this.props;
    const { value } = this.state;
    const routeData = this.props.nextStopComplianceSelectedRoute;
    const routeComplianceData = this.props.routeComplianceData;
    return stopDetails ? (
      <div className={classes.subModulePart}>
        <Tabs
          value={value}
          onChange={this.handleChange}
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabsIndicator,
          }}
        >
          <Tab
            disableRipple
            classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            label="End of Day Route Compliance"
          />
          <Tab
            disableRipple
            classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            label="Driver Decision at Each Stop"
          />
        </Tabs>
        {value === 0 && (
          <EndOfDayRouteCompliance
            stopChange={this.stopChange}
            routeData={routeData}
            routeComplianceData={routeComplianceData}
            selectedRoute={selectedRoute}
            stopDetails={stopDetails}
            terminalCode={terminalCode}
          />
        )}
        {value === 1 && (
          <DriverDecisionPerStop
            stopDetails={stopDetails}
            routeData={routeData}
            routeComplianceData={routeComplianceData}
            selectedRoute={selectedRoute}
            onStopClick={onStopClick}
            stopIndex={stopIndex}
          />
        )}
      </div>
    ) : (
      <NoData dataUpdateInProgress={dataUpdateInProgress} />
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme()
)(NextStopComplianceDetails);
